// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomConnectWalletButton_root__KP2mZ"};